import env from "react-dotenv";
import { CARPETA_QR } from "../constants/catalogoInventario.constants";
import type { FilaInventario, QrProducto, ResultadoQrMasivo } from "../types/catalogoInventario.types";

const escaparHtml = (texto: string): string =>
    texto.replace(
        /[&<>"']/g,
        (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c] as string)
    );

export const urlImagenQr = (archivo: string): string =>
    `${env.API_URL_ASSETS}${CARPETA_QR}/${archivo}`;

export const esSeleccionableQr = (fila: FilaInventario): boolean => fila.activo && !fila.qr;

export const descargarQr = async (qr: QrProducto): Promise<void> => {
    try {
        const respuesta = await fetch(qr.urlImagen);
        if (!respuesta.ok) throw new Error("No se pudo descargar el QR");
        const url = URL.createObjectURL(await respuesta.blob());
        const enlace = document.createElement("a");
        enlace.href = url;
        enlace.download = `${qr.clave}.png`;
        enlace.click();
        URL.revokeObjectURL(url);
    } catch {
        window.open(qr.urlImagen, "_blank");
    }
};

export const imprimirQr = (qr: QrProducto): void => {
    const ventana = window.open("", "_blank", "width=400,height=500");
    if (!ventana) return;
    ventana.document.write(`
        <html>
            <head><title>${escaparHtml(qr.clave)}</title></head>
            <body style="margin:0;display:flex;flex-direction:column;align-items:center;font-family:sans-serif">
                <img src="${escaparHtml(qr.urlImagen)}" style="width:250px" onload="window.print();window.close();" />
            </body>
        </html>
    `);
    ventana.document.close();
};

const plural = (n: number, singular: string, varios: string) => `${n} ${n === 1 ? singular : varios}`;

export const mensajeResultadoQr = ({ generados, existentes, fallidos }: ResultadoQrMasivo): string => {
    const partes: string[] = [];
    if (generados.length) partes.push(plural(generados.length, "QR generado", "QR generados"));
    if (existentes.length)
        partes.push(plural(existentes.length, "producto ya tenía QR", "productos ya tenían QR"));
    if (fallidos.length) partes.push(plural(fallidos.length, "no se pudo generar", "no se pudieron generar"));
    return partes.length ? `${partes.join(", ")}.` : "No hubo productos por generar.";
};
